namespace Solovis.UI {

    export interface ModalWaitPanelOptions {
        zIndex?: number;
    }

    /**
     * ModalWaitPanel will display a modal wait panel that blocks the user interface until it is removed.
     */
    export class ModalWaitPanel {

        private _options: ModalWaitPanelOptions;

        private _waitDialogInfo = null;

        constructor(options: ModalWaitPanelOptions) {
            this._options = options ? options : {};
        }

        public show() {
            // if (Solovis.UX.Utils.isNewUxEnabled()) {
            //     Solovis.UX.Utils.showLoader();
            //     return;
            // }

            if (!this._waitDialogInfo) {
                this._waitDialogInfo = {};

                let waitDialogElement = $("<div>")
                    .css("position", "fixed")
                    .css("top", "0").css("left", "0")
                    .css("width", "100%").css("height", "100%")
                    .css("display", "none").css("pointer-events", "none");

                let container = $("<div style='position: relative; width: 100%; height: 100%;'></div>").appendTo(waitDialogElement);
                let backgroundDiv = $("<div style='position: fixed; width: 100%; height: 100%; background-color: #000; opacity: 0.6'></div>").appendTo(container);

                let waitImageDiv = Solovis.UI.StockAnimations.createSpinningCircles(
                    {
                        diameter: "100px",
                        top: "50%",
                        left: "50%",
                        showShadow: true
                    })
                    .appendTo(container);

                this._waitDialogInfo.waitDialogElement = waitDialogElement;
                this._waitDialogInfo.waitImageDiv = waitImageDiv;
                $(document.body).append(this._waitDialogInfo.waitDialogElement);

                let zIndexToUse;
                if (Solovis.isNotNull(this._options.zIndex)) {
                    zIndexToUse = this._options.zIndex;
                }
                else {
                    zIndexToUse = Solovis.UI.DomHelper.findMaxZIndexForElementChildren(document.body);
                    zIndexToUse = zIndexToUse + 5;
                }

                this._waitDialogInfo.waitDialogElement.css("z-index", zIndexToUse);
                this._waitDialogInfo.waitDialogElement.css("display", "block");
            }
        }

        public hide() {
            // if (Solovis.UX.Utils.isNewUxEnabled()) {
            //     Solovis.UX.Utils.hideLoader();
            //     return;
            // }

            if (this._waitDialogInfo) {
                this._waitDialogInfo.waitDialogElement.remove();
                this._waitDialogInfo = null;
            }
        }

        public dispose() {
            this.hide();
        }
    }

}